import SimpleBar from 'simplebar-react';

import { alpha, lighten, styled } from '@mui/material/styles';

const NAV_BG = '#374852';

// ----------------------------------------------------------------------

export const StyledRootScrollbar = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
}));

export const StyledScrollbar = styled(SimpleBar)(({ theme }) => ({
  maxHeight: '100%',
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
    },
    '&.simplebar-visible:before': {
      opacity: 1,
    },
  },
  '& .simplebar-mask': {
    zIndex: 'inherit',
    backgroundColor: NAV_BG,
    backgroundImage: `linear-gradient(165deg, ${lighten(NAV_BG, 0.15)} 0%, ${NAV_BG} 55%)`,

    '& a': {
      color: '#fff',
    }
  },
}));
